import { useRestApiProvider } from "@jugl-web/rest-api";
import { previewTasksAdapter } from "@jugl-web/rest-api/tasks";
import { useCallback, useMemo } from "react";

interface UseSelectTaskByIdOptions {
  entityId: string;
}

export const useSelectTaskById = ({ entityId }: UseSelectTaskByIdOptions) => {
  const { tasksApi } = useRestApiProvider();

  const { data: taskEntityState } = tasksApi.endpoints.getTasks.useQueryState({
    entityId,
  });

  const { data: teamTaskEntityState } =
    tasksApi.endpoints.getTeamTasks.useQueryState({
      entityId,
    });

  const adapterSelectors = useMemo(
    () => previewTasksAdapter.getSelectors(),
    []
  );

  // Searches for a task in both personal and team task collections
  const selectTaskById = useCallback(
    (taskId: string) => {
      const maybePersonalTask = adapterSelectors.selectById(
        taskEntityState ?? previewTasksAdapter.getInitialState(),
        taskId
      );

      if (maybePersonalTask) {
        return maybePersonalTask;
      }

      const maybeTeamTask = adapterSelectors.selectById(
        teamTaskEntityState ?? previewTasksAdapter.getInitialState(),
        taskId
      );

      return maybeTeamTask;
    },
    [adapterSelectors, taskEntityState, teamTaskEntityState]
  );

  return selectTaskById;
};
